//TODO (Chelsi): rename these? 600px is generally used as our mobile breakpoint

export const mobileBreakpoint = '800px';
export const materialSMBreakpoint = '600px';
// iPhone 5 screen is 320px wide. This breakpoint is used for iphone5 specific adjustments:
export const smallPhoneBreakpoint = '321px';

export default {
  mobileBreakpoint,
  materialSMBreakpoint,
  smallPhoneBreakpoint,
};
